/* eslint-disable no-continue */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  addLayerToMap,
  getAllClickedFeatures,
  getAllFeaturesByDetail,
  removeComponentLayers,
  zoomToGeojsonGeometryWithBuffer,
} from 'utils/map/map';
import { createLayer } from 'utils/map/layers';
import { hasObjectKeys } from 'utils/main';
import { setSelectedApprovedAreas } from 'store/actions/map/selectedApprovedAreas';
import { Grid, Typography } from '@material-ui/core';
import { formStyles } from 'consts/styles/Form';

import {
  addApprovedAreasToLayer,
  setAreasBasicStyle,
  setSelectedAreaStyle,
} from './utils/main';
import DashboardApprovedAreasDetails from './DisplayDashboard';

const ApprovedAreasDashboard = () => {
  const approvedAreas = useSelector(state => state.approvedAreas);
  const selectedApprovedAreas = useSelector(
    state => state.selectedApprovedAreas
  );
  const map = useSelector(state => state.map);
  const strings = useSelector(state => state.language).zonesDetails;
  const [approvedAreasToDisplay, setApprovedAreasToDisplay] = React.useState(
    []
  );
  const dispatch = useDispatch();
  const layer = React.useRef(null);

  const formClasses = formStyles();

  const mapInit = () => {
    if (!hasObjectKeys(map)) return;
    layer.current = createLayer('approvedAreas');
    addLayerToMap(map, layer.current);
    map.on('click', handleClick);
    return () => cleanup();
  };

  React.useEffect(mapInit, [map]);

  React.useEffect(() => {
    addApprovedAreasToLayer(layer.current, approvedAreas);
  }, [approvedAreas]);

  const handleClick = evt => {
    const approvedAreasFeatures = getAllFeaturesByDetail(
      getAllClickedFeatures(map, evt),
      'approvedArea'
    );
    dispatch(setSelectedApprovedAreas(approvedAreasFeatures));
  };

  const cleanup = () => {
    removeComponentLayers(map);
    map.un('click', handleClick);
  };

  const zoom = geojson => {
    zoomToGeojsonGeometryWithBuffer(map, geojson);
  };

  React.useEffect(() => {
    const areas = getSelectedAreasFromAll();
    handleSelectedAreasChange(areas);
    setApprovedAreasToDisplay(areas);
  }, [selectedApprovedAreas]);

  const getSelectedAreasFromAll = () => {
    const areas = [];
    let pastUid = '';
    for (const area of selectedApprovedAreas) {
      const properties = area.getProperties();
      if (pastUid === properties.uid) continue;
      const founded = approvedAreas.find(a => a.uid === properties.uid);
      if (founded) areas.push(founded);
      pastUid = properties.uid;
    }
    return areas;
  };

  const handleSelectedAreasChange = areas => {
    setAreasBasicStyle(layer.current);
    if (areas.length === 1) setSelectedAreaStyle(layer.current, areas[0].uid);
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item xs={12}>
          {approvedAreasToDisplay.length ? (
            <DashboardApprovedAreasDetails
              zoom={zoom}
              approvedAreas={approvedAreasToDisplay}
            />
          ) : (
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {strings.noItems_}
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ApprovedAreasDashboard;
